import { render, staticRenderFns } from "./SiteStatistics.vue?vue&type=template&id=d4ecde5c&scoped=true"
import script from "./SiteStatistics.vue?vue&type=script&lang=js"
export * from "./SiteStatistics.vue?vue&type=script&lang=js"
import style0 from "./SiteStatistics.vue?vue&type=style&index=0&id=d4ecde5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ecde5c",
  null
  
)

export default component.exports